import React from 'react';
import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// import { FiUserCheck, FiHome } from "react-icons/fi";
// import { MdOutlineVerifiedUser } from "react-icons/md";
// import { AiOutlineForm } from "react-icons/ai";
// import { BsPerson } from "react-icons/bs";
// import { OwlCarousel } from 'react-owl-carousel';  
// import 'owl.carousel/dist/assets/owl.carousel.css';  
// import 'owl.carousel/dist/assets/owl.theme.default.css';

export default function Home() {
    // const options = {
    //     items: 1,
    //     nav: true,
    //     rewind: true,
    //     autoplay: true
    // };
    return (
        <div>
            <Carousel indicators={false} controls={false}>
                <Carousel.Item>
                    <video className='carousal-video' autoPlay muted loop src="./assets/videos/main-carousal-video.mp4"></video>
                    <Carousel.Caption className='main-heading'>
                        <h1 className='main-heading1'>AMOSTA</h1>
                        <h1 className='main-heading2'>LIVING TECHNOLOGY</h1>
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>
            <div className="container section2 text-center mt-5">
                <h1 className='section2-heading'>Amosta World of Mobility & Connectivity</h1>
                <p align='justify'>Amosta is a Technology Company, Committed to Cater The Requirements of THE PEOPLE to live a Better & Happy Life in era of Internet Of Things, Futuristic Smart Cities, Connected World & Super Intelligent Ecosystem.</p>
                <p align='justify'>Be it your business, your family, your organization, your field resources, your remote assets or your workforce, everything is now a DOT on big Matrix of connected world.</p>

                <p align='justify'>We Equip Businesses & Organizations with Our Well Researched Solutions to exceed their Productivity, Efficiency, ROI and Business Objectives.</p>

                <p align='justify'>With key Focus on Process Automation, Internet of Things ( IOT ), Manufacturing 2.0, Artificial Intelligence, Augmented Reality, Virtual Reality, Data Analysis & Smart Living, Amosta is firm to bring solutions to make this place a happier place to live.</p>
            </div>

            <div className="container home-added-section mt-5">
                <div className="row">
                    <div className="col-sm-6 col-md-4">
                        <div className="card mt-5 card-home-added-section shadow rounded">
                            <Link className='bg-dark btn-home-added-section' to='./hum-hai-seva-kendra'>
                                <div className="card-head card-head-home-added-section rounded">
                                    <img className='img-fluid w-100 rounded img-home-added-section' src="./assets/images/Hum hai seva kendra.jpg" alt="seva kendra" />
                                </div>
                                <div className="card-body card-body-home-added-section bg-dark text-center">
                                    Hum Hai Seva Kendra
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4">
                        <div className="card mt-5 card-home-added-section shadow rounded">
                            <Link className='bg-dark btn-home-added-section' to='./verification'>
                                <div className="card-head card-head-home-added-section rounded">
                                    <img className='img-fluid w-100 rounded img-home-added-section' src="./assets/images/Identity Management Solution-small.jpg" alt="seva kendra" />
                                </div>
                                <div className="card-body card-body-home-added-section bg-dark text-center">
                                    Identity Management Solutions
                                </div></Link>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4">
                        <div className="card mt-5 card-home-added-section shadow rounded">
                            <Link className='bg-dark btn-home-added-section' to='./led-lights'>
                                <div className="card-head card-head-home-added-section rounded">
                                    <img className='img-fluid w-100 rounded img-home-added-section' src="./assets/images/LED Lights.jpg" alt="seva kendra" />
                                </div>
                                <div className="card-body card-body-home-added-section bg-dark text-center">
                                    LED Lights Solutions
                                </div></Link>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4">
                        <div className="card mt-5 card-home-added-section shadow rounded">
                            <Link className='bg-dark btn-home-added-section' to='./gst-robo'>
                                <div className="card-head card-head-home-added-section rounded">
                                    <img className='img-fluid w-100 rounded img-home-added-section' src="./assets/images/GST ROBO.jpg" alt="seva kendra" />
                                </div>
                                <div className="card-body card-body-home-added-section bg-dark text-center">
                                    GST Robo
                                </div></Link>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4">
                        <div className="card mt-5 card-home-added-section shadow rounded">
                            <Link className='bg-dark btn-home-added-section' to='./digital-signage-solutions'>
                                <div className="card-head card-head-home-added-section rounded">
                                    <img className='img-fluid w-100 rounded img-home-added-section' src="./assets/images/Digital Signage Solutions.jpg" alt="seva kendra" />
                                </div>
                                <div className="card-body card-body-home-added-section bg-dark text-center">
                                    Digital Signage Solutions
                                </div></Link>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4">
                        <div className="card mt-5 card-home-added-section shadow rounded">
                            <Link className='bg-dark btn-home-added-section' to='./vehicle-telematics-solutions'>
                                <div className="card-head card-head-home-added-section rounded">
                                    <img className='img-fluid w-100 rounded img-home-added-section' src="./assets/images/Vehicle Telematics Solutions-2.jpg" alt="seva kendra" />
                                </div>
                                <div className="card-body card-body-home-added-section bg-dark text-center">
                                    Vehicle Telematics Solutions
                                </div></Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-light">
                <div className="container section3 mt-5 p-3">
                    <div className="row">
                        <div className="col-md-3 col-sm-12 section3-robo">
                            <img className='img-fluid' src="assets/images/gst-robo.png" alt="gst-robo" />
                        </div>
                        <div className="col-md-9 col-sm-12 mt-2 section3-cards">
                            <div className="card section3-card">
                                <img className='img-fluid section3-logos' src="assets/images/tax.png" alt="GST SOFTWARE" />
                                <p className='section3-cards-text'>GST Software</p>
                            </div>
                            <div className="card section3-card">
                                <img className='img-fluid section3-logos' src="assets/images/e-way.png" alt="GST SOFTWARE" />
                                <p className='section3-cards-text'>E-Way Bills</p>
                            </div>
                            <div className="card section3-card">
                                <img className='img-fluid section3-logos' src="assets/images/gstn.png" alt="GST SOFTWARE" />
                                <p className='section3-cards-text'>GSTN's E-Invoice</p>
                            </div>
                            <div className="card section3-card">
                                <img className='img-fluid section3-logos' src="assets/images/billing.png" alt="GST SOFTWARE" />
                                <p className='section3-cards-text'>Billing Software</p>
                            </div>
                            <div className="card section3-card">
                                <img className='img-fluid section3-logos' src="assets/images/gst-return.png" alt="GST SOFTWARE" />
                                <p className='section3-cards-text'>GST Return Filing</p>
                            </div>
                            <div className="card section3-card">
                                <img className='img-fluid section3-logos' src="assets/images/intelligence.png" alt="GST SOFTWARE" />
                                <p className='section3-cards-text'>Intelligence-Insight</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container section4 mt-5 p-3">
                <div className="row text-center">
                    <div className="col-md-6 col-sm-12">
                        <img className='img-fluid section4-img' src="assets/images/section4-img.jpg" alt="section4-img" />
                    </div>
                    <div className="col-md-6 col-sm-12 section4-right-cont">
                        <div className="container section4-right-cont">
                            <img className='img-fluid acp-logo mt-3' src="assets/images/acp-logo-lg.png" alt="" />
                            <p className='acp-heading'>AMOSTA CONNECT PROGRAM</p>
                            <p className='acp-down-heading'>Business For All</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-light">
                <div className="container section5 mt-5 p-3 text-center">
                    <h1 className='section2-heading m-3'>Identity Management Solution</h1>
                    {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis doloremque numquam esse voluptates unde incidunt molestias.</p> */}
                    <img className='img-fluid rounded-2' src="assets/images/identity.jpg" alt="hello.jpg" />
                    <div className="section5-cards mt-5">
                        <div className="card section-5-card mt-4">
                            <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/Background Verification-Red.png' />
                            <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/Background Verification-White.png' />
                            <h5 className='section5-card-text mt-3'>Background Verification</h5>
                        </div>
                        <div className="card section-5-card mt-4">
                            <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/Police Verification-Red.png' />
                            <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/Police Verification-White.png' />
                            <h5 className='section5-card-text mt-3'>Police Verification</h5>
                        </div>
                        <div className="card section-5-card mt-4">
                            <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/Residence Verification-Red.png' />
                            <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/Residence Verification-White.png' />
                            <h5 className='section5-card-text mt-3'>Residence Verification</h5>
                        </div>
                        <div className="card section-5-card mt-4">
                            <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/Employment Verification-Red.png' />
                            <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/Employment Verification-White.png' />
                            <h5 className='section5-card-text mt-3'>Employment Verification</h5>
                        </div>
                        <div className="card section-5-card mt-4">
                            <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/Criminal Recode Check-Red.png' />
                            <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/Criminal Recode Check-White.png' />
                            <h5 className='section5-card-text mt-3'>Criminal Recode Check</h5>
                        </div>
                        <div className="card section-5-card mt-4">
                            <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/Education Verification-Red.png' />
                            <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/Education Verification-White.png' />
                            <h5 className='section5-card-text mt-3'>Education Verification</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container section-6 mt-5 p-3">
                {/* <OwlCarousel className='owl-theme'>
                    <div class='item'>
                        <h4>1</h4>
                    </div>
                    <div class='item'>
                        <h4>2</h4>
                    </div>
                    <div class='item'>
                        <h4>3</h4>
                    </div>
                    <div class='item'>
                        <h4>4</h4>
                    </div>
                    <div class='item'>
                        <h4>5</h4>
                    </div>
                    <div class='item'>
                        <h4>6</h4>
                    </div>
                    <div class='item'>
                        <h4>7</h4>
                    </div>
                    <div class='item'>
                        <h4>8</h4>
                    </div>
                </OwlCarousel>; */}
            </div>
        </div>
    )
}
